import { SliderStoreFactory } from './chunk-53B74NMI.js';
import { $ariaBool } from './chunk-EVP5E6AO.js';
import { useMedia } from './chunk-ZIBTY3GT.js';
import { $$_create_walker, $$_effect, $$_attr, $$_listen, $$_ref, $$_create_template } from 'maverick.js/dom';
import { signal, useStore, computed, effect } from 'maverick.js';
import { defineElement, Component } from 'maverick.js/element';

var $$_templ = /* @__PURE__ */ $$_create_template(`<!$><video muted="" playsinline="" preload="auto" part="video" style="max-width: unset"></video>`);
var SliderVideo = class extends Component {
  constructor() {
    super(...arguments);
    this.k = null;
    this._a = signal(false);
    this.zc = signal(false);
  }
  onAttach() {
    this.a = useMedia();
    this.H = useStore(SliderStoreFactory);
    this.da = computed(this.Bg.bind(this));
    this.Ac = computed(this.v.bind(this));
    this.setAttributes({
      "data-loading": this.xc.bind(this),
      "aria-hidden": $ariaBool(this.Ac)
    });
    effect(this.Cg.bind(this));
    effect(this.Dg.bind(this));
  }
  onConnect() {
    if (this.k.readyState >= 2)
      this.gb();
  }
  render() {
    const { crossorigin } = this.a.$store;
    return (() => {
      const [$$_root, $$_walker] = $$_create_walker($$_templ);
      $$_effect(() => $$_attr($$_root, "src", this.da()));
      $$_effect(() => $$_attr($$_root, "crossorigin", crossorigin()));
      $$_listen($$_root, "canplay", this.gb.bind(this));
      $$_listen($$_root, "error", this.ia.bind(this));
      $$_ref($$_root, this.Eg.bind(this));
      return $$_root;
    })();
  }
  Bg() {
    const { canLoad } = this.a.$store;
    return canLoad() ? this.$props.src() : null;
  }
  xc() {
    return !this._a() && !this.Ac();
  }
  v() {
    const { duration } = this.a.$store;
    return !!this.zc() || !this._a() || !Number.isFinite(duration());
  }
  Cg() {
    this.da();
    this._a.set(false);
    this.zc.set(false);
  }
  gb(event) {
    this._a.set(true);
    this.dispatch("can-play", { trigger: event });
  }
  ia(event) {
    this.zc.set(true);
    this.dispatch("error", { trigger: event });
  }
  Dg() {
    const { duration } = this.a.$store;
    const { pointerRate } = this.H;
    if (this._a() && this.k && Number.isFinite(duration()) && Number.isFinite(pointerRate())) {
      this.k.currentTime = pointerRate() * duration();
    }
  }
  Eg(el) {
    this.k = el;
  }
};
SliderVideo.el = defineElement({
  tagName: "media-slider-video",
  props: { src: void 0 }
});

export { SliderVideo };
